import { useTranslation } from 'react-i18next';

import { UserAvatar } from '@app/shared/ui/atoms/Common';
import { Gender } from '@app/shared/types/common';
import { diamondIcon } from '@app/assets';

interface NameLabelProps {
  name?: string | null;
  avatar?: string | null;
  gender?: Gender;
  level?: number;
  peopleCount?: number;
  diamondsCount?: number;
  isUserLoading?: boolean;
}

export function NameSection({
  name,
  avatar,
  gender,
  level,
  peopleCount,
  diamondsCount,
  isUserLoading = false,
}: NameLabelProps) {
  const { t } = useTranslation();

  return (
    <div className="relative mt-4">
      <h3 className="w-[calc(100%-128px)] wrap-break-word text-xl font-semibold text-foreground sm:w-[calc(100%-168px)] sm:text-2xl">
        {name}
      </h3>

      <div className="absolute -top-6 right-0 z-10">
        <UserAvatar
          avatar={avatar}
          isAvatarLoading={isUserLoading}
          gender={gender}
          className="size-[120px] sm:size-40"
        />

        <div className="absolute -bottom-8 right-0 flex flex-col items-center rounded-lg bg-[#1faeff] p-1 text-xs font-medium text-foreground sm:px-3 sm:py-1 sm:text-sm">
          <span>
            {level ?? 0} {t('user_profile.level')}
          </span>
          <span>👥: {peopleCount ?? 0}</span>
          <div className="flex items-center">
            <img src={diamondIcon} alt="diamond" className="h-4 w-4" />
            <span>: {diamondsCount ?? 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
